import { AbstractMermaidTokenBuilder } from '../common/index.js';

export class TreemapTokenBuilder extends AbstractMermaidTokenBuilder {
  public constructor() {
    super(['treemap']);
  }
}
